import { createApp } from '@backstage/frontend-defaults';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { infraModule } from './modules/infra';
import { themeModule } from './modules/theme';
import {
  scaffolderModule,
  scaffolderWrapperModule,
} from './modules/scaffolder';
import argocdPlugin, {
  argocdTranslationsModule,
} from '@backstage-community/plugin-argocd';
import { byxCatalogPlugin, catalogTranslationsModule } from './modules/catalog';
import { authModule } from './modules/auth';
import { apisModule } from './modules/apis';
import { entityModule, entityTranslationsModule } from './modules/entity';
import { byxTechdocsPlugin, docsTranslationsModule } from './modules/docs';
import { byxSearchPlugin, searchTranslationsModule } from './modules/search';
import {
  byxCatalogImportPlugin,
  catalogImportTranslationsModule,
} from './modules/catalogImport';
import {
  byxCatalogGraphPlugin,
  catalogGraphTranslationsModule,
} from './modules/catalogGraph';
import {
  byxUserSettingsPlugin,
  settingsTranslationsModule,
} from './modules/settings';
import { notificationsTranslationsModule } from './modules/notifications';
import { errorPagesModule } from './modules/errorPages';
import { localeModule } from './modules/locale';

type AppFeatures = NonNullable<
  NonNullable<Parameters<typeof createApp>[0]>['features']
>;

/** The app's own features; the installed plugins are discovered on top. */
export const appFeatures: AppFeatures = [
  authModule,
  byxCatalogPlugin,
  catalogTranslationsModule,
  // PDO-2636: abas Deployment Lifecycle/Summary nos componentes com
  // argocd/app-selector (anotados pelo byx-catalog).
  argocdPlugin,
  argocdTranslationsModule,
  navModule,
  homeModule,
  infraModule,
  themeModule,
  scaffolderModule,
  scaffolderWrapperModule,
  // Story 1.7: /api-docs redirects to the Catálogo APIs tab.
  apisModule,
  // Stories 3.1–3.3: entity header and tabs, Componente overview cards and
  // the Dependências tab.
  entityModule,
  // Story 2.2: pt-BR texts of the stock pieces on the entity pages, Busca
  // and Docs.
  entityTranslationsModule,
  searchTranslationsModule,
  docsTranslationsModule,
  // Story 5.4: Docs index in the Catálogo language.
  byxTechdocsPlugin,
  // Story 5.3: Busca in the Catálogo language, the query from the top bar.
  byxSearchPlugin,
  // Story 5.5: Registrar existente (permission guard kept) and Configurações
  // in the v2 design.
  byxCatalogImportPlugin,
  byxUserSettingsPlugin,
  // Story 2.3: pt-BR texts of Registrar existente, Configurações and
  // Notificações.
  catalogImportTranslationsModule,
  settingsTranslationsModule,
  notificationsTranslationsModule,
  // Stories 5.5, 2.3: Grafo do catálogo in the v2 design and its pt-BR
  // stock texts.
  byxCatalogGraphPlugin,
  catalogGraphTranslationsModule,
  // U5-9 (AC-30): the pt-BR Página não encontrada in place of the stock 404.
  errorPagesModule,
  // Q-31 (AC-32): stock dates and relative times in the portal language.
  localeModule,
];

export default createApp({
  features: appFeatures,
});
